import React from 'react';
import khushi from '../Images/team/khushi.png';
import umar from '../Images/team/me.png';
import rumaisa from '../Images/team/rumaisa.png';
import sara from '../Images/team/sara2.png';
import osama from '../Images/team/osama.png';
import '../team.css';
import LinkedinIcon from '../Images/LINKED IN PNG.png';

const OurTeam = () => {
  const teamMembers = [
    {
      image: khushi,
      name: 'Khushi Muhammad',
      expertise: 'Founder & CEO',
      info: 'As a Computer Science graduate and AR enthusiast, I combine technical expertise with visionary leadership to pioneer innovative solutions that redefine user experiences at Visuar Solutions',
      linkedin: 'https://www.linkedin.com/in/khushi-muhammad/',
    },
    {
      image: umar,
      name: 'Umar Shahzad',
      expertise: 'AR & Web Developer',
      info: 'I am a team lead at Visuar Solutions, I drag my AR and web development expertise to create impactful & interactive tools',
      linkedin: 'https://www.linkedin.com/in/umarshahzad683/',
    },
    {
      image: sara,
      name: 'Sara Afzaal',
      expertise: 'Unity Developer',
      info: 'Unity developer and social media manager at Visuar Solutions, blending tech and creativity to engage and inspire.',
      linkedin: 'https://www.linkedin.com/in/sara-afzaal-0b6690297/',
    },
    {
      image: rumaisa,
      name: 'Rumaisa Fatima',
      expertise: 'Business Executive',
      info: 'Business executive at Visuar Solutions, building connections and driving growth with passion and purpose',
      linkedin: 'https://www.linkedin.com/in/rumaisa-fatima-64b019311/',
    },
    {
      image: osama,
      name: 'Osama Mehram',
      expertise: 'Web Developer',
      info: 'Web developer at Visuar Solutions, dedicated to creating seamless and user-friendly digital experiences',
      linkedin: 'https://www.linkedin.com/in/raja-osama-364b3b314/',
    },
  ];

  return (
    <div className="our-team">
      <h2>Meet Our Team</h2>
      <div className="main-member">
        <div className="main-member-left">
          <img src={teamMembers[0].image} alt={teamMembers[0].name} className="main-member-img" />
        </div>
        <div className="main-member-right">
          <div className='name_linkedin'>
            <h3>{teamMembers[0].name}</h3>
            <a href={teamMembers[0].linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-link">
              <img src={LinkedinIcon} alt="LinkedIn" />
            </a>

          </div>
          <p className="expertise">{teamMembers[0].expertise}</p>
          <p className="info">{teamMembers[0].info}</p>
        </div>
      </div>
      
      <div className="team-grid">
        {teamMembers.slice(1).map((member, index) => (
          <div className="team-member" key={index}>
            <img src={member.image} alt={member.name} className="team-member-img" />
            <div className='infoDiv'>
              <div className='name_linkedin'>
                <h3>{member.name}</h3>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-link">
                  <img src={LinkedinIcon} alt="LinkedIn" />
                </a>
              </div>
                <p className="expertise">{member.expertise}</p>
                <p className="info">{member.info}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
